import colors from "@variables/colors";

const boxShadow = {
  1: `0px 3px 6px ${colors.gray[400]}`,
  2: "8px 8px 9px #a7a7a780",
};

export default boxShadow;
